import { Input } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { ReactElement, useState } from 'react';

import FormItemWithLabel from '../../../components/Form/FormItemWithLabel';
import { DocumentReceiptEntity } from '../../../generated-api';
import TrainingPermissionCheckbox from '../TrainingPermissionCheckbox';
import PayeeInput from './PayeeInput';
import ReceiptDetailForm from './ReceiptDetailForm';

type FormProps = {
  documentId: string;
  entity: DocumentReceiptEntity;
  groupId: string;
  changed: boolean;
  setChanged: (newValue: boolean) => void;
  path?: NamePath;
};

export function ReceiptFormInputs({
  changed,
  documentId,
  entity,
  groupId,
  path = [],
  setChanged,
}: FormProps): ReactElement {
  // detail で payee の変更を検知するために使用する
  const [inputPayee, setInputPayee] = useState<string | null>(entity.payee?.[0] ?? null);
  const onPayeeChange = async (value: string) => {
    setInputPayee(value);
  };
  return (
    <>
      <FormItemWithLabel initialValue={entity.payment_date} label="支払い日付" name="payment_date" path={path}>
        <Input />
      </FormItemWithLabel>
      <PayeeInput path={path} payees={entity.payee ?? []} onChange={onPayeeChange} />
      <FormItemWithLabel initialValue={entity.business_number} label="事業者番号" name="business_number" path={path}>
        <Input />
      </FormItemWithLabel>
      <ReceiptDetailForm
        changed={changed}
        entity={entity}
        inputPayee={inputPayee}
        path={path}
        setChanged={setChanged}
      />
      <TrainingPermissionCheckbox documentId={documentId} groupId={groupId} />
    </>
  );
}
